<div class="root">
  <div class="top">
    <div style="align-items: start; text-align: start">
      <span class="cursor" style="color: #0054a6">
        Home > {{ pledgeBody?.campaign_title }} >
      </span>
      <span> Proceed to Payment</span>
    </div>
  </div>

  <div class="main_body">
    <div class="inner_main_body">
      <div class="back"><span class="cursor" (click)="goBack()">&#x2B05; Back</span></div>
      <h1 class="stay-updated-with">
        Enter Your Payment Information to Confirm Donation
      </h1>

      <div class="amount_pic">
        <img src="./assets/images/icon/money_icon.svg" alt="round_tk" />
        <div class="amount_text">
          Amount:
          <span class="blue">BDT {{ pledgeBody?.amount | number }}</span>
        </div>
      </div>

      <div class="description">
        <h1 class="desc">Shohay does not process payments directly.</h1>
        <div class="description_desc">
          To donate, first contact Shohay Ops to receive payment details
        </div>
      </div>

      <div class="details_section">
        <h1 class="desc">Contact Shohay Ops for Payment Details:</h1>
        <div class="phone">
          <img
            src="./assets/images/icon/phone-call.svg"
            alt="phone"
            srcset=""
          />
          <div class="number">+8801786062801</div>
        </div>
        <div class="phone">
          <img src="./assets/images/icon/email.svg" alt="phone" srcset="" />
          <div class="number" style="color: #0054a6">
            support&#64;shohay.net
          </div>
        </div>
        <div class="phone">
          <img
            src="./assets/images/icon/whatsapp_icon.svg"
            alt="phone"
            srcset=""
          />
          <div class="number" style="color: #0054a6">+8801786062801</div>
        </div>
      </div>

      <div class="payment_section">
        <div>
          <div class="header1">
            Enter your payment details to confirm your donation
          </div>
          <!-- <div class="description_desc">
            To donate, first contact Shohay Ops to receive payment details.
          </div> -->
        </div>

        <div class="form-group">
          <div class="input_div">
            <label class="field-label requiredMark"
              >Upload Payment Receipt</label
            >
            <div
              class="file-upload-container"
              (drop)="onDropSuccess($event)"
              (dragover)="onDragOver($event)"
            >
              <label class="w-100">
                <dx-text-box
                  class="uploader_input_field w-100"
                  placeholder="Drag and drop files here or browse file"
                  [ngModel]="receiptName"
                  [readOnly]="true"
                  [showClearButton]="false"
                >
                  <dx-validator validationGroup="validationGrp">
                    <dxi-validation-rule
                      type="required"
                      message="Receipt is required."
                    >
                    </dxi-validation-rule>
                  </dx-validator>
                </dx-text-box>
                <input
                  #ngoLogoInput
                  type="file"
                  class="box-file"
                  id="ngoLogoInput"
                  (change)="onFileChange($event)"
                  aria-hidden="true"
                  accept=".jpg, .jpeg, .png, .pdf"
                  [multiple]="false"
                />
              </label>
              <div
                class="blue-button-md"
                type="button"
                (click)="triggerFileInput('ngoLogoInput')"
              >
                Browse File
              </div>
            </div>
            <div class="field_footer_label">
              Find your receipt in: SMS, banking app, or email confirmation.
            </div>
          </div>
        </div>

        <!-- <div class="d-flex gap-2 flex-column">
          <div class="description_desc fw-bold mb-2">
            Receipt Submission Guidelines:
          </div>
          <div class="description_desc">
            <span class="fw-bold px-2">• Where to find your receipt? </span>
            <span>bKash/Nagad: Check transaction history in the app.</span>
          </div>
          <div class="description_desc">
            <span class="fw-bold px-2">• Bank transfer: </span>
            <span>
              Download the e-statement or transaction receipt from online
              banking.
            </span>
          </div>
          <div class="description_desc">
            <span class="fw-bold px-2">• </span>
            <span>
              You can also take a screenshot of the payment confirmation SMS
              from your bank or MFS provider and upload it as proof.
            </span>
          </div>
          <div class="description_desc">
            <span class="fw-bold px-2">• </span>
            <span>Accepted file formats: PDF, JPEG, PNG.</span>
          </div>
          <div class="description_desc">
            <span class="fw-bold px-2">• </span><span>Max file size: </span>
            <span class="fw-bold">5MB.</span>
          </div>
        </div> -->

        <div class="pay_buttons">
          <div class="yellow-button-lg cursor" [routerLink]="['/contact-us']">
            Contact Support
          </div>
          <div class="blue-button-lg cursor" (click)="submit()">Submit</div>
        </div>
      </div>
    </div>
  </div>
</div>
